import { createApp } from "vue";
import App from "./App.vue";
import importe from "./directives/importe";
import router from "./router";
import store from "./store";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faBroom } from "@fortawesome/free-solid-svg-icons/faBroom";
import { faBell } from "@fortawesome/free-solid-svg-icons/faBell";
import { faCalculator } from "@fortawesome/free-solid-svg-icons/faCalculator";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons/faCartShopping";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons/faFileExcel";
import { faFileInvoice } from "@fortawesome/free-solid-svg-icons/faFileInvoice";
import { faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons/faFileInvoiceDollar";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons/faFilePdf";
import { faFilter } from "@fortawesome/free-solid-svg-icons/faFilter";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons/faFloppyDisk";
import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons/faPenToSquare";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faPrint } from "@fortawesome/free-solid-svg-icons/faPrint";
import { faReceipt } from "@fortawesome/free-solid-svg-icons/faReceipt";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons/faRightFromBracket";
import { faRotate } from "@fortawesome/free-solid-svg-icons/faRotate";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { faUpload } from "@fortawesome/free-solid-svg-icons/faUpload";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { faWallet } from "@fortawesome/free-solid-svg-icons/faWallet";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "./styles/admin-theme.css";

library.add(
  faArrowLeft,
  faBell,
  faBroom,
  faCalculator,
  faCartShopping,
  faCheck,
  faCirclePlus,
  faDownload,
  faEye,
  faFileExcel,
  faFileInvoice,
  faFileInvoiceDollar,
  faFilePdf,
  faFilter,
  faFloppyDisk,
  faGear,
  faMagnifyingGlass,
  faPaperPlane,
  faPenToSquare,
  faPlus,
  faPrint,
  faReceipt,
  faRightFromBracket,
  faRotate,
  faTrash,
  faUpload,
  faUser,
  faUsers,
  faWallet,
  faXmark
);

createApp(App)
  .directive("importe", importe)
  .component("FontAwesomeIcon", FontAwesomeIcon)
  .use(store)
  .use(router)
  .mount("#app");
